define('OutSystems/ReactView/LazyScreen',["require", "exports", "tslib", "react"], function (require, exports, tslib_1, react_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LazyScreen = (function (_super) {
        tslib_1.__extends(LazyScreen, _super);
        function LazyScreen(props, context) {
            return _super.call(this, props, context) || this;
        }
        LazyScreen.prototype.componentDidMount = function () {
            var onEnter = this.props.onEnter;
            if (onEnter) {
                onEnter();
            }
        };
        LazyScreen.prototype.componentWillUnmount = function () {
            var onLeave = this.props.onLeave;
            if (onLeave) {
                onLeave();
            }
        };
        LazyScreen.prototype.render = function () {
            var component = this.props.component;
            return component ? react_1.createElement(component, this.props) : null;
        };
        return LazyScreen;
    }(react_1.Component));
    exports.default = LazyScreen;
});
//# sourceMappingURL=LazyScreen.js.map;
